import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Plus, Save, Trash2 } from "lucide-react";

const RouteRow = ({ r, i, onChange, onRemove }) => (
  <div className="grid grid-cols-[1fr_2fr_auto] gap-2 items-end" data-testid={`wa-fwd-row-${i}`}>
    <div>
      {i === 0 && <Label className="text-[10px] uppercase tracking-widest text-zinc-500">Phone Number ID</Label>}
      <Input value={r.phone_number_id} onChange={e => onChange({ ...r, phone_number_id: e.target.value })}
        className="rounded-sm mt-1 font-mono" data-testid={`wa-fwd-pnid-${i}`} />
    </div>
    <div>
      {i === 0 && <Label className="text-[10px] uppercase tracking-widest text-zinc-500">URL Webhook</Label>}
      <Input value={r.url} onChange={e => onChange({ ...r, url: e.target.value })} placeholder="https://..."
        className="rounded-sm mt-1 font-mono" data-testid={`wa-fwd-url-${i}`} />
    </div>
    <Button variant="outline" size="icon" onClick={onRemove} className="rounded-sm" data-testid={`wa-fwd-remove-${i}`}>
      <Trash2 className="w-4 h-4" />
    </Button>
  </div>
);

export const WaForwardRoutes = () => {
  const [routes, setRoutes] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.waForwardRoutes().then(d => setRoutes(d.routes || [])).catch(() => {}); }, []);
  const update = (i, v) => setRoutes(rs => rs.map((r, j) => (j === i ? v : r)));
  const save = async () => {
    setSaving(true);
    try {
      const d = await api.waForwardRoutesSave(routes.filter(r => r.phone_number_id || r.url));
      setRoutes(d.routes);
      toast.success("Routing nomor tambahan disimpan");
    } catch (e) {
      toast.error(e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || "Gagal menyimpan");
    } finally { setSaving(false); }
  };
  return (
    <div className="border border-border bg-white rounded-sm p-5" data-testid="wa-forward-routes">
      <h2 className="font-['Manrope'] font-bold mb-1">Nomor Tambahan (WABA Sama)</h2>
      <div className="text-[12px] text-zinc-600 mb-4">
        Webhook untuk Phone Number ID di bawah diteruskan apa adanya ke URL tujuan dan tidak diproses di sini.
      </div>
      <div className="space-y-2">
        {routes.length === 0 && <div className="text-[12px] text-zinc-500" data-testid="wa-fwd-empty">Belum ada nomor tambahan.</div>}
        {routes.map((r, i) => (
          <RouteRow key={i} r={r} i={i} onChange={v => update(i, v)} onRemove={() => setRoutes(rs => rs.filter((_, j) => j !== i))} />
        ))}
      </div>
      <div className="flex gap-2 mt-4">
        <Button variant="outline" className="rounded-sm" onClick={() => setRoutes(rs => [...rs, { phone_number_id: "", url: "" }])} data-testid="wa-fwd-add">
          <Plus className="w-4 h-4 mr-1" /> Tambah Nomor
        </Button>
        <Button className="rounded-sm" onClick={save} disabled={saving} data-testid="wa-fwd-save">
          <Save className="w-4 h-4 mr-1" /> {saving ? "Menyimpan..." : "Simpan Routing"}
        </Button>
      </div>
    </div>
  );
};
